import { useTranslation } from 'react-i18next';
import { differenceInMinutes } from 'date-fns';

import { useCountDown } from '@sternum/web/hooks/useCountDown';
import { namespaces } from '@sternum/web/services/i18n';

export interface CountdownProps {
  translationKey: string;
  initialValueInMs: number;
  rateLimit: number;
}

export function Countdown({ translationKey, initialValueInMs, rateLimit }: CountdownProps) {
  const { t } = useTranslation(namespaces.auth);
  const amountToSubtract = 1000; // every minute
  const value = useCountDown({ from: initialValueInMs, to: 0, amountToSubtract });
  const minutes = differenceInMinutes(value, 0);

  return <span>{t(translationKey, { limit: rateLimit, minutes })}</span>;
}
